import { GridTemplateCondition } from '@/shared/types/grid';

export const gridTemplateCondition = <T>(condition: GridTemplateCondition<T>) => {
  // Template doesn't seem to interpret value === null or value === undefined correctly, test for falsiness intead
  if (condition.value === null || condition.value === undefined) {
    return `${condition.negate ? '' : '!'}${condition.field}`;
  } else if (typeof condition.value === 'boolean') {
    return `${condition.value && !condition.negate ? '' : '!'}${condition.field}`;
  } else {
    const toggleIfValue =
      typeof condition.value === 'string' ? `"${condition.value.replace('"', '\\"')}"` : condition.value;

    return `${condition.field} ${condition.negate ? '!' : '='}== ${toggleIfValue}`;
  }
};
